import Container, { filterShape } from './container'

export {
  filterShape
}

export default Container


// WEBPACK FOOTER //
// ./src/gov-registrations/index.js